export enum CaseDecision {
  Reject = 'Reject the on-boarding process',
  Approve = 'Approve the on-boarding process',
  Hold = 'Hold the on-boarding process'
}

export enum EllipticCaseDecision {
  C = 'Close',
  O = 'Comment',
  OR = 'Open and Report',
  CR = 'Close and Report',
  R = 'Reopen'
}

export enum AbrdnCaseDecision {
  Report = 'Report',
  Investigate = 'Investigate',
  Closed = 'Close',
  Escalate = 'Escalate'
}

export enum CaseRiskLevel {
  L = 'Low',
  M = 'Medium',
  H = 'High',
  U = 'Unacceptable'
}

export enum TravelRuleCaseDecision {
  O = 'Open',
  C = 'Closed'
}

export enum TransactionCaseDecision {
  Approve = 'Approve',
  Reject = 'Reject',
  Hold = 'Hold'
}
